import HighchartsRuntime from 'highcharts/es-modules/masters/highcharts.src.js';
import type HighchartsNamespace from 'highcharts';
import type { PlotColumnrangeOptions } from 'highcharts';
import type { HighchartsSeriesTypes } from './highcharts.types';

export const FLAME_SERIES_OPTIONS = {
  cursor: 'pointer',
  dataLabels: {
    enabled: true,
    format: '{point.name}',
    inside: true,
    align: 'center',
    crop: true,
    overflow: 'none',
    color: 'black',
    padding: 1,
    style: {
      textOutline: 'none',
      fontWeight: 'normal',
      textOverflow: 'ellipsis',
    },
  },
  pointPadding: 0,
  groupPadding: 0,
} as unknown as PlotColumnrangeOptions;

export const Highcharts = HighchartsRuntime as unknown as typeof HighchartsNamespace;

// Highcharts does not type its internal registered series prototypes.
export const seriesTypes = (Highcharts as typeof HighchartsNamespace & { seriesTypes: HighchartsSeriesTypes })
  .seriesTypes;
